export default __webpack_public_path__ + "static/media/county_boundaries.3107c118.geojson";